import Button from '@hubins/components/Button';
import FormModal from '@hubins/components/FormModal';
import Heading from '@hubins/components/Heading';
import { LoadingBox } from '@hubins/components/LoadingIndicators';
import BasicFixedFooter from 'components/BasicFixedFooter';
import { Column, Columns } from 'components/Columns';
import { createAnswer, getSummary } from 'helpers/form';
import EditableSummary from 'modules/EditableSummary';
import React, { useEffect, useRef, useState } from 'react';

const CRMEditableSummary = ({
  formKey,
  title,
  name,
  profileUuid,
  portfolioUuid,
  userId = false,
  editable = true,
}) => {
  const [summary, setSummary] = useState(false);
  const [loading, setLoading] = useState(false);
  const submitRef = useRef(null);

  useEffect(() => {
    setSummary(false);
    getSummary(formKey, profileUuid, portfolioUuid, setSummary, userId);
  }, [formKey, profileUuid, portfolioUuid, userId]);

  const submit = () => {
    submitRef.current.click();
  };

  const handleSubmit = async (form) => {
    setLoading(true);
    const formBody = {
      profileUuid,
      portfolioUuid,
      ...form,
      status: 'success',
    };
    createAnswer(formBody);
    setLoading(false);
  };

  if (summary === false) return <LoadingBox />;

  if (typeof summary.response !== 'undefined' && summary.response.length === 0) {
    return <>Inget resultat hittat</>;
  }

  return (
    <>
      <Columns className="no-side-padding">
        <Column xs="12" className="s-top-s-womq">
          <Heading size="3">{title}</Heading>
        </Column>
        <Column s="12" className="flex flex--row space-between">
          {editable && <FormModal content={summary.content} response={summary.response} />}
        </Column>
        <Column s="12">
          <EditableSummary
            summary={summary}
            submit={handleSubmit}
            submitRef={submitRef}
            editable={editable}
            hideSubmit
          />
        </Column>
      </Columns>
      {editable && (
        <BasicFixedFooter>
          <Button onClick={submit} className="cta" loading={loading} disabled={loading}>
            Update
          </Button>
        </BasicFixedFooter>
      )}
    </>
  );
};

export default CRMEditableSummary;
